import { z } from 'zod'

export const STRATALYST_COMMERCIAL_CONTRACT_VERSION = '1.0.0' as const
export const stratalystCommercialResponseSchema = z.unknown()
export type StratalystCommercialResponse = z.infer<typeof stratalystCommercialResponseSchema>
